import { createModal } from '/@/core/elements/modal'
import type { ProjectInfo } from '/@/common/projects/types'

interface NewProjectModalData {
  mode: 'simple' | 'full'
  context?: string
  onSubmit?: ((project: ProjectInfo, isNew: boolean) => void) | null
  onCancel?: (() => void) | null
  strict?: boolean
}

const { api: useNewProjectModal, component: NewProjectModal } =
  createModal<NewProjectModalData>(
    'NewProjectModal',
    () => import('./NewProjectModal.vue'),
    {
      mode: 'full',
      onSubmit: null,
      onCancel: null,
      strict: false,
    },
  )

export { NewProjectModal, useNewProjectModal }
